module.exports = __webpack_public_path__ + "static/media/blog_44.d61133b4.webp";